import * as React from 'react';
import PropTypes from 'prop-types';

import Snackbar from 'components/Snackbar';

import UserSetup from './UserSetup';
import DemoModal from './DemoModal';
import Contact from './Contact';
import ProvideFeedback from './ProvideFeedback';
import UnsavedChanges from './UnsavedChanges';
import VideoModal from './VideoModal/VideoModal';
import TrelloModal from './TrelloModal/TrelloModal';
import AsanaModal from './AsanaModal/TrelloModal';
import SimilarPagesModal from './SimilarPagesModal/SimilarPagesModal';

const App = ({
  children,
  snackbar,
  closeSnackbar,
  currentUser,
  finishUserSetup,
  updateProfile,
  showDemoModal,
  closeDemoModal,
  showProvideFeedbackModal,
  closeProvideFeedbackModal,
  openSubmitFeedback,
  closeContactModal,
  contactUs,
  submitContact,
  inspectExitCallback,
  inspectChangesCount,
  confirmInspectExit,
  confirmInspectStay,
  confirmInspectSaveExit,
  feedbackSubmit,
  videoModal,
  hideVideoModal,
  showTrelloGuide,
  closeTrelloGuide,
  showAsanaGuide,
  closeAsanaGuide,
  similarPages,
  resetSimilarPages,
  addSimilarPages,
  pages,
}) => (
  <>
    {children}
    <Snackbar
      show={snackbar.showSnackbar}
      message={snackbar.message}
      closeSnackbar={closeSnackbar}
    />
    <DemoModal show={showDemoModal} closeDemoModal={closeDemoModal} />
    <VideoModal
      show={videoModal.showVideoModal}
      source={videoModal.source}
      toggleModal={hideVideoModal}
      isCommentVideo={videoModal.isCommentVideo}
    />
    {Object.keys(currentUser).length > 0 && (
      <>
        {finishUserSetup && (
          <UserSetup currentUser={currentUser} updateProfile={updateProfile} />
        )}
        <Contact
          closeModal={closeContactModal}
          contactUs={contactUs}
          user={currentUser}
          submitContact={submitContact}
          feedbackSubmit={feedbackSubmit}
        />
        <ProvideFeedback
          show={showProvideFeedbackModal}
          closeModal={closeProvideFeedbackModal}
          openSubmitFeedback={openSubmitFeedback}
        />
        {inspectExitCallback && (
          <UnsavedChanges
            changes={inspectChangesCount}
            exit={confirmInspectExit}
            stay={confirmInspectStay}
            save={confirmInspectSaveExit}
          />
        )}
        {showTrelloGuide && <TrelloModal closeTrelloGuide={closeTrelloGuide} />}
        {showAsanaGuide && <AsanaModal closeTrelloGuide={closeAsanaGuide} />}
        <SimilarPagesModal
          similarPages={similarPages}
          resetSimilarPages={resetSimilarPages}
          addSimilarPages={addSimilarPages}
          limit={currentUser.projectPagesCount || 5}
          pages={pages}
        />
      </>
    )}
    <div id="dropdowns-container" />
  </>
);

App.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]).isRequired,
  snackbar: PropTypes.object.isRequired,
  closeSnackbar: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
  finishUserSetup: PropTypes.bool.isRequired,
  updateProfile: PropTypes.func.isRequired,
  showDemoModal: PropTypes.bool.isRequired,
  showProvideFeedbackModal: PropTypes.bool.isRequired,
  contactUs: PropTypes.object.isRequired,
  closeDemoModal: PropTypes.func.isRequired,
  closeContactModal: PropTypes.func.isRequired,
  closeProvideFeedbackModal: PropTypes.func.isRequired,
  openSubmitFeedback: PropTypes.func.isRequired,
  submitContact: PropTypes.func.isRequired,
  inspectExitCallback: PropTypes.object,
  inspectChangesCount: PropTypes.number.isRequired,
  confirmInspectExit: PropTypes.func.isRequired,
  confirmInspectSaveExit: PropTypes.func.isRequired,
  confirmInspectStay: PropTypes.func.isRequired,
  feedbackSubmit: PropTypes.func.isRequired,
  videoModal: PropTypes.object.isRequired,
  hideVideoModal: PropTypes.func.isRequired,
  showTrelloGuide: PropTypes.bool.isRequired,
  closeTrelloGuide: PropTypes.func.isRequired,
  showAsanaGuide: PropTypes.bool.isRequired,
  closeAsanaGuide: PropTypes.func.isRequired,
  similarPages: PropTypes.object.isRequired,
  resetSimilarPages: PropTypes.func.isRequired,
  addSimilarPages: PropTypes.func.isRequired,
  pages: PropTypes.array.isRequired,
};

export default App;
